export default [
  {
    title: "Approved",
    key: "approved",
    original_key: "approved",
    value: true
  },
  {
    title: "Invoiced",
    key: "invoiced",
    original_key: "invoiced",
    value: true
  },
  {
    title: "Paid",
    key: "paid",
    original_key: "paid",
    value: true
  },
  {
    title: "Not Approved",
    key: "not_approved",
    original_key: "approved",
    value: false
  },
  {
    title: "Not Invoiced",
    key: "not_invoiced",
    original_key: "invoiced",
    value: false
  },
  {
    title: "Not Paid",
    key: "not_paid",
    original_key: "paid",
    value: false
  },
]
